/**
 * FIP Edit Modal
 *
 * Allows toggling of FIP active status.
 */

import React, { useEffect, useState, useCallback } from 'react';
import { Button, Toggle } from 'equal-ds-ui';
import type { FipEditModalProps } from '../../../types/fip-list';

export const FipEditModal: React.FC<FipEditModalProps> = ({
  isOpen,
  record,
  onClose,
  onSubmit,
  isSubmitting,
}) => {
  const [status, setStatus] = useState<boolean>(record?.status ?? false);

  useEffect(() => {
    if (record) {
      setStatus(Boolean(record.status));
    }
  }, [record]);

  const handleToggle = useCallback(() => {
    if (isSubmitting) {
      return;
    }
    setStatus((prev) => !prev);
  }, [isSubmitting]);

  if (!isOpen || !record) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="px-6 py-4 border-b border-border-default">
          <h2 className="text-lg font-semibold text-text-primary">
            {record.fipName}
          </h2>
          <p className="text-sm text-text-secondary mt-1">
            Toggle the FIP activation status.
          </p>
        </div>

        <div className="px-6 py-6 space-y-4">
          <Toggle
            title="Activate / Deactivate"
            description="Toggle the FIP activation status"
            enabled={status}
            onToggle={handleToggle}
            disabled={isSubmitting}
            className="border-0"
          />
        </div>

        <div className="px-6 py-4 border-t border-border-default flex justify-end gap-3">
          <Button variant="secondary" size="sm" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => onSubmit(status)}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Updating...' : 'Update'}
          </Button>
        </div>
      </div>
    </div>
  );
};
